module.exports = __webpack_public_path__ + "682e619492101dbbd5fce65323137817.pdf";